export const DELETE_USER_CONFIRM_MESSAGE: string =
  "Are you sure you want to delete user";
